<template>
  <div class="right_content">
    <div class="electrical_title">
      <i class="icon-electric iconfont"></i>
      <span class="text">：{{ eleCount }}</span>
      <i class="icon-water iconfont"></i>
      <span class="text">：{{ watCount }}</span>
      <span>{{ levelData.detailAddress || "--" }}</span>
    </div>
    <div class="operation_button">
      <el-form :inline="true">
        <el-form-item>
          <el-input
            class="input_query"
            :placeholder="$t('lang.请输入')"
            prefix-icon="el-icon-search"
            v-model="queryForm.searchValue"
            @keyup.enter.native="onClickQuery"
          />
        </el-form-item>
        <el-form-item :label="$t('lang.状态')">
          <el-select v-model="queryForm.queryType">
            <el-option
              v-for="item in deviceStatusList"
              :key="item.value"
              :label="$t('lang.' + item.label)"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.排序')">
          <el-select v-model="queryForm.sortType">
            <el-option
              v-for="item in deviceSortList"
              :key="item.value"
              :label="$t('lang.' + item.label)"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onClickQuery">
            {{ $t("lang.查询") }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="onClickAddDevice">
            {{ $t("lang.添加设备") }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="onClickPriceAdjust">
            {{ $t("lang.价格调整") }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      height="calc(100% - 0.9rem)"
      v-loading="loading"
    >
      <el-table-column
        v-for="item in deviceLabel"
        :key="item.prop"
        :label="$t('lang.' + item.label)"
        :prop="item.prop"
        :width="item.width"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="item.prop == 'status'" class="round_status">
            <span
              :style="{
                background: statusColorFilter(scope.row[item.prop]),
              }"
            ></span>
            <span
              v-if="scope.row.deviceType == 0"
              :style="{
                color: statusColorFilter(scope.row[item.prop]),
                width: '90px',
                textAlign: 'left',
              }"
            >
              {{ $t("lang." + statusFilter(scope.row[item.prop])) }}
            </span>
            <span
              v-if="scope.row.deviceType == 1"
              :style="{
                color: statusColorFilter(scope.row[item.prop]),
                width: '90px',
                textAlign: 'left',
              }"
            >
              {{ $t("lang." + WaterStatusFilter(scope.row[item.prop])) }}
            </span>
          </div>
          <div v-else-if="item.prop === 'remainKwh'">
            {{ getRemain(scope.row) }}
          </div>
          <div v-else>{{ scope.row[item.prop] || "--" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.操作')"
        :width="$i18n.locale == 'zh-CN' ? '300' : '400'"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="table_operation">
            <el-button type="text" @click="onClickDetails(scope.row)">
              {{ $t("lang.查看详情") }}
            </el-button>
            <span>|</span>
            <el-button type="text" @click="onClickChangeTenants(scope.row)">
              {{ $t("lang.更换租客") }}
            </el-button>
            <span>|</span>
            <el-button type="text" @click="onClickRecharge(scope.row)">
              {{ $t("lang.代客充值") }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="payment_bottom">
      <el-pagination
        class="bottom_page"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :current-page="params.pageNum"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizes"
        :page-size="10"
        :total="params.totalCount"
      >
      </el-pagination>
    </div>
    <!-- 添加设备 -->
    <DeviceDialog ref="deviceDialogRef" />
    <!-- 电价调整 -->
    <PriceDialog ref="priceDialogRef" />
    <!-- 代客充值 -->
    <RechargeDialog ref="rechargeDialogRef" />
    <!-- 查看详情 -->
    <DetailsDrawer ref="detailsDrawerRef" />
    <!-- 更换租客 -->
    <TenantsDialog ref="tenantsDialogRef" />
    <!-- 水表代客充值 -->
    <WaterRechargeDialog ref="waterRechargeDialogRef" />
  </div>
</template>

<script>
import { deviceStatus, deviceSort, deviceLabel } from "../define";
import { statusColorFilter, statusFilter, waterStatusFilter } from "../filter";
import DeviceDialog from "../dialog/device-dialog.vue";
import PriceDialog from "../dialog/price-dialog.vue";
import RechargeDialog from "../dialog/recharge-dialog.vue";
import DetailsDrawer from "./details-drawer.vue";
import TenantsDialog from "../dialog/tenants-dialog.vue";
import { mapActions } from "vuex";
import WaterRechargeDialog from "../dialog/water-recharge-dialog";
export default {
  components: {
    WaterRechargeDialog,
    DeviceDialog,
    PriceDialog,
    RechargeDialog,
    DetailsDrawer,
    TenantsDialog,
  },
  inject: ["equipmentPage"],
  data() {
    return {
      deviceStatusList: deviceStatus,
      deviceSortList: deviceSort,
      deviceLabel: deviceLabel,
      statusColorFilter: statusColorFilter,
      statusFilter: statusFilter,
      WaterStatusFilter: waterStatusFilter,
      queryForm: {
        searchValue: "",
        queryType: "",
        sortType: "",
        rootId: 0,
      },
      params: {
        pageNum: 1,
        pageSize: 10,
        totalCount: 0,
      },
      pageSizes: [10, 20, 50, 100],
      loading: false,
      tableData: [],
      levelData: {},
      eleCount: 0,
      watCount: 0,
    };
  },
  mounted() {},
  created() {},
  methods: {
    ...mapActions({
      electricityPricesList: "ZD_ElectricityPricesList",
      waterPricesList: "ZD_WaterPricesList",
      deviceListV2: "ZD_RootDeviceListV2",
    }),
    handleCurrentChange(val) {
      this.params.pageNum = val;
      this.iDeviceListV2();
    },
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.iDeviceListV2();
    },
    async iDeviceListV2() {
      try {
        this.loading = true;
        let res = await this.deviceListV2({ rootId: this.queryForm.rootId });
        if (res.success !== 1) throw new Error("");
        let tempList = res.value.deviceList || [];

        //#region 前端筛选
        tempList = tempList
          .filter((item) => {
            const { searchValue } = this.queryForm;
            if (!searchValue) return true;
            const deviceMatch =
              item.deviceName && item.deviceName.includes(searchValue);
            const tagMatch = item.tagNo && item.tagNo.includes(searchValue);
            const nameMatch =
              item.nickName && item.nickName.includes(searchValue);
            const phoneMatch = item.phone && item.phone.includes(searchValue);
            return deviceMatch || tagMatch || nameMatch || phoneMatch;
          })
          .filter((item) => {
            const { queryType } = this.queryForm;
            if (!queryType) return true;
            switch (queryType) {
              case 1:
                return item.status === 1;
              case 2:
                return item.status === 0;
              case 3:
                return item.status === -1;
              default:
                return true;
            }
          })
          .sort((a, b) => {
            const { sortType } = this.queryForm;
            if (!sortType) return 0;
            const hasA =
              "remainKwh" in a &&
              a.remainKwh !== null &&
              a.remainKwh !== undefined;
            const hasB =
              "remainKwh" in b &&
              b.remainKwh !== null &&
              b.remainKwh !== undefined;
            if (!hasA && !hasB) return 0;
            if (!hasA) return 1;
            if (!hasB) return -1;
            const diff = a.remainKwh - b.remainKwh;
            return sortType === 1 ? -diff : diff; // 1: 降序（大在前），2: 升序（小在前）
          });
        const { pageNum, pageSize } = this.params;
        const startIndex = (pageNum - 1) * pageSize;
        const paginatedList = tempList.slice(startIndex, startIndex + pageSize);
        //#endregion

        //#region 设备数量统计
        let tempEle = 0,
          tempWat = 0;
        tempList.forEach((elem) => {
          if (elem.deviceType === 0) tempEle++;
          else tempWat++;
        });
        this.eleCount = tempEle;
        this.watCount = tempWat;
        //#endregion

        this.tableData = paginatedList;
        this.params.totalCount = tempList.length;
        this.levelData = res.value;
      } catch (e) {
        this.tableData = [];
        this.eleCount = 0;
        this.watCount = 0;
        this.params.totalCount = 0;
      } finally {
        this.loading = false;
      }
    },
    /**设备列表 */
    async getDeviceList(rootId) {
      this.queryForm.rootId = rootId;
      this.iDeviceListV2();
    },
    /**查询 */
    onClickQuery() {
      this.params.pageNum = 1;
      this.iDeviceListV2();
    },
    /**添加设备 */
    async onClickAddDevice() {
      if (!this.checkLevelData()) return;
      let res = await this.electricityPricesList({});
      let resWater = await this.waterPricesList({});
      if (res.success !== 1) return (this.$refs.deviceDialogRef.priceList = []);
      this.$refs.deviceDialogRef.priceList = res.listitem;
      if (resWater.success !== 1)
        return (this.$refs.deviceDialogRef.waterPriceList = []);
      this.$refs.deviceDialogRef.waterPriceList = resWater.listitem;
      if (res.listitem.length == 0) {
        this.$confirm(this.$t("lang.您还未设置电价"), this.$t("lang.提示"), {
          confirmButtonText: this.$t("lang.去设置"),
          cancelButtonText: this.$t("lang.取消"),
          type: "warning",
        })
          .then(async () => {
            this.$router.push("/priceControl");
          })
          .catch(() => {});
      } else {
        this.$refs.deviceDialogRef.dialogVisible = true;
      }
    },
    /**电价调整 */
    async onClickPriceAdjust() {
      this.$refs.priceDialogRef.showDialog();
      let res = await this.electricityPricesList({});
      let resWater = await this.waterPricesList({});
      if (res.success !== 1) return (this.$refs.priceDialogRef.priceList = []);
      this.$refs.priceDialogRef.priceList = res.listitem;
      if (resWater.success !== 1)
        return (this.$refs.priceDialogRef.waterPriceList = []);
      this.$refs.priceDialogRef.waterPriceList = resWater.listitem;
    },
    /**查看详情 */
    onClickDetails(row) {
      this.$refs.detailsDrawerRef.showDialog(row.pointId, row.deviceType);
    },
    /**代客充值 */
    onClickRecharge(data) {
      switch (data.deviceType) {
        case 0:
          this.$refs.rechargeDialogRef.showDialog(data);
          break;
        case 1:
          this.$refs.waterRechargeDialogRef.showDialog(data);
          break;
        default:
          break;
      }
    },
    /**更换租客 */
    onClickChangeTenants(data) {
      this.$refs.tenantsDialogRef.showDialog(data, 1);
    },
    /**检查是否有层级 */
    checkLevelData() {
      let levelLength =
        this.equipmentPage.$refs.leftHierarchyRef.levelData.length;
      if (levelLength == 0) {
        this.$confirm(
          this.$t("lang.您还未创建分组请先添加分组"),
          this.$t("lang.提示"),
          {
            confirmButtonText: this.$t("lang.确定"),
            cancelButtonText: this.$t("lang.取消"),
            type: "warning",
          }
        )
          .then(async () => {})
          .catch(() => {});
      }
      return levelLength > 0;
    },
    getRemain(row) {
      if (this.isnull(row.remainKwh)) return "--";
      return `${this.fix(row.remainKwh)}${
        row.deviceType === 0 ? "kW·h" : "m³"
      }`;
    },
  },
};
</script>

<style scoped lang='less'>
.right_content {
  padding-left: 20px;
  width: calc(100% - 270px);
  position: relative;
}
.electrical_title {
  margin-top: 10px;
  color: #666;
  font-size: 14px;
  .icon-electric {
    color: #ea9c2d;
  }
  .icon-water {
    color: rgb(104, 176, 238);
  }
  .text {
    color: #999;
    margin-right: 22px;
  }
}
.operation_button {
  margin: 15px 0 0 0;
}
.el-form-item {
  margin-right: 24px;
}
.table_operation {
  span {
    color: #409eff;
    margin: 0 5px;
  }
}
.round_status {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  span:first-child {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
  }
}
.payment_bottom {
  width: 100%;
  height: 60px;
  .bottom_page {
    position: absolute;
    bottom: 0;
    right: 20px;
  }
}
</style>
